import React from "react";
import "./About.css";
import aboutImg from "../../Assets/images/aboutbook.jpg";

const About = () => {
  return (
    <section className="about">
      <div className="container">
        <div className="section-title">
          <h2>About</h2>
        </div>

        <div className="about-content grid">
          <div className="about-img">
            <img src={aboutImg} alt="about img" />
          </div>

          <div className="about-text">
            <h2 className="about-title fs-26 ls-1">About Librium</h2>
            <p className="fs-17 ">
              {" "}
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Voluptatem enim, quaerat facilis ea excepturi et ut laborum eum
              neque dolore aspernatur exercitationem esse, similique, porro
              perferendis minima dolorem laudantium consectetur. Eligendi cum
              eos inventore, ea ipsum explicabo quae alias? Quae culpa
              voluptates et odit at!
            </p>

            <p className="fs-17">Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores natus, quaerat laudantium aspernatur quibusdam alias temporibus accusantium dignissimos neque obcaecati explicabo excepturi, consectetur harum, tempore eligendi sequi facilis id nesciunt.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
